import api from '../../../../../api/client';
import React, { useState } from "react";
import { Drawer, Button, Badge } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import ChatContainer from "./ChatContainer";

const ChatList = () => {
  const [chatOpen, setChatOpen] = useState(false);
  const currentUser = useSelector((state) => state.account.user);

  return (
    <>
      <Button
        type="primary"
        shape="circle"
        icon={<MessageOutlined />}
        size="large"
        onClick={() => setChatOpen(true)}
        style={{
          position: "fixed",
          bottom: 24,
          right: 24,
          zIndex: 1000,
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
        }}
      />
      <Drawer
        title="Chats"
        placement="right"
        width={900}
        open={chatOpen}
        onClose={() => setChatOpen(false)}
        closable
        destroyOnClose
      >
        <ChatContainer currentUser={currentUser} />
      </Drawer>
    </>
  );
};

export default ChatList;